import React from 'react';
import { EmailBlock, ButtonBlockContent } from '../types';
import { splitTextWithMergeTags, MERGE_TAGS } from '../utils/mergeTagHelper';

interface ButtonBlockProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

export const ButtonBlock: React.FC<ButtonBlockProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const content = block.content as ButtonBlockContent;

  const buttonStyle: React.CSSProperties = {
    backgroundColor: content.backgroundColor || '#3b82f6',
    color: content.textColor || '#ffffff',
    fontSize: content.fontSize || 16,
    fontWeight: content.fontWeight || 'bold',
    padding: content.padding || '12px 24px',
    borderRadius: content.borderRadius || '4px',
    borderWidth: content.borderWidth || '0',
    borderColor: content.borderColor || 'transparent',
    borderStyle: content.borderStyle || 'solid',
    textDecoration: 'none',
    display: 'inline-block',
    textAlign: 'center',
    width: content.width || 'auto',
    ...block.styles
  };

  const containerStyle: React.CSSProperties = {
    textAlign: content.align || 'center',
    padding: '10px'
  };

  const renderButtonContent = () => {
    if (!content.text) return null;
    
    const parts = splitTextWithMergeTags(content.text);
    return parts.map((part, index) => {
      if (part.type === 'text') {
        return <React.Fragment key={`text-${index}`}>{part.content}</React.Fragment>;
      } else {
        // Render badge for merge tag
        const tag = MERGE_TAGS.find(t => t.value === part.content);
        const displayName = tag ? tag.name : part.tagName || part.content;
        return (
          <span
            key={`badge-${index}`}
            className={`
              inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium ml-1 mr-1
              ${isDarkMode
                ? 'bg-white/20 text-white border border-white/30'
                : 'bg-white/30 text-white border border-white/50'
              }
            `}
            title={tag ? `Sample: ${tag.sample}` : ''}
          >
            {displayName}
          </span>
        );
      }
    });
  };

  const buttonContent = renderButtonContent();

  const buttonElement = (
    <span style={buttonStyle}>
      {buttonContent}
    </span>
  );

  const wrapper = content.link ? (
    <a href={content.link} style={buttonStyle}>
      {buttonContent}
    </a>
  ) : buttonElement;

  return (
    <div style={containerStyle}>
      {wrapper}
    </div>
  );
};
